/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷可能フラグ（木曜日）
 * @export
 * @interface EnableShipdayThu
 */
export interface EnableShipdayThu {
}

/**
 * Check if a given object implements the EnableShipdayThu interface.
 */
export function instanceOfEnableShipdayThu(value: object): value is EnableShipdayThu {
    return true;
}

export function EnableShipdayThuFromJSON(json: any): EnableShipdayThu {
    return EnableShipdayThuFromJSONTyped(json, false);
}

export function EnableShipdayThuFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableShipdayThu {
    return json;
}

export function EnableShipdayThuToJSON(json: any): EnableShipdayThu {
    return EnableShipdayThuToJSONTyped(json, false);
}

export function EnableShipdayThuToJSONTyped(value?: EnableShipdayThu | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

